<script setup lang="ts">
const productContent = useProductContentStore()
const { lastArticleInChapter } = useChapterProgress()
</script>

<template>
  <ClientOnly fallback-tag="footer">
    <footer
      v-if="!productContent.hydrationInProgress"
      class="fixed bottom-0 right-0 z-20 w-full bg-[--theme-darkest] py-6 text-white md:z-30 md:px-28"
    >
      <UArticleFooterLast v-if="lastArticleInChapter" />
      <UArticleFooterNext v-else />

      <UMarketingBanner v-if="productContent.nextArticle?.restricted" />
    </footer>
  </ClientOnly>
</template>
